define("settings/components/groups/group-cover", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/service", "@ember/object", "ember-concurrency-decorators"], function (_exports, _component, _templateFactory, _component2, _service, _object, _emberConcurrencyDecorators) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <tr>
    {{!-- Group Details --}}
    <td>
      <div class="o--user">
        {{!-- Group Avatar --}}
        <div class="o--user__avatar cNA--group__avatar">
          {{#if @group.imageUrl}}
            <img class="cNA--group__avatar--img" src={{@group.imageUrl}}>
          {{else}}
            <span class="cNA--group__avatar--text">
              {{word-initials @group.name}}
            </span>
          {{/if}}
        </div>
        <div class="u--p__l__xs">
          {{!-- Group Name --}}
          <div class="o--user__title u--ellipsis">
            <span>{{@group.name}}</span>
          </div>
          {{!-- Group Role --}}
          <span class="u--block">
            {{t
              "account.groups.table.user_count"
              count=@group.nonContributorMemberCount
            }}
          </span>
          {{#if this.currentAccount.canContributors}}
            <span class="u--block" data-test-id="contributors count">
              {{t "account.groups.table.contributor_count"
                  count=@group.contributorCount
                }}
            </span>
          {{/if}}
        </div>
      </div>
    </td>
    {{!-- Social Sets --}}
    <td>
      <DragSortList
        @items={{this.identities}}
        @dragEndAction={{perform this.tradeIdentities}}
        @draggingEnabled={{true}}
        @additionalArgs={{hash group=@group}}
        @handle="[draggable]"
        @determineForeignPositionAction={{action "determineForeignPosition"}}
        @childClass="cSS--setWrapper"
        class="parentList"
        as |socialIdentity index|
      >
        <Shared::SocialIdentity
          @socialIdentity={{socialIdentity.identity}}
          @editable={{@editable}}
          @trade={{perform this.tradeSocialProfile}}
          @index={{index}}
          @clickedDetails={{action "goToDetails"}}
        />
      </DragSortList>
    </td>
    {{!-- Action --}}
    <td class="at--holisticOnboarding__editButtonCell">
  
      {{#if @showProfileList}}
        {{#each this.socialIdentities as |set|}}
          <div class="cSS--detail">
  
            {{#if set.temporaryProfiles}}
              <SocialIdentity::SortProfiles @profiles={{set.temporaryProfiles}} as |orderedProfiles|>
                {{#each orderedProfiles.orderedProfiles as |profile|}}
                  <div class="cSS--detail__li">
                    <i class="i--{{profile.profile.profileType}}"></i> {{profile.profile.displayNickname}}
                  </div>
                {{/each}}
              </SocialIdentity::SortProfiles>
            {{else}}
              <SocialIdentity::SortProfiles @profiles={{set.socialProfiles}} as |orderedProfiles|>
                {{#each orderedProfiles.orderedProfiles as |profile|}}
                  <div class="cSS--detail__li">
                    <i class="i--{{profile.profileType}}"></i> {{profile.displayNickname}}
                  </div>
                {{/each}}
              </SocialIdentity::SortProfiles>
            {{/if}}
          </div>
        {{/each}}
      {{/if}}
  
      {{#if (and (not @showProfileList) this.currentUser.isAccountOwner)}}
        <LinkTo
          @route="groups.group"
          @model={{@group}}
          @query={{hash new_social_profile_id=null}}
          class="o--btn o--btn--outline u--float--right u--p__lr__md {{if @isFirstGroup "at--autoPublish__socialProfileDetails at--autoPublishEnable__socialProfileDetails at--holisticLibrary__socialSetsAndAccessGroups--editBtn"}}"
        >
          {{t "account.groups.table.button"}}
        </LinkTo>
      {{/if}}
    </td>
  </tr>
  
  */
  {
    "id": "al63MSZI",
    "block": "[[[10,\"tr\"],[12],[1,\"\\n\"],[1,\"  \"],[10,\"td\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"o--user\"],[12],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"o--user__avatar cNA--group__avatar\"],[12],[1,\"\\n\"],[41,[30,1,[\"imageUrl\"]],[[[1,\"          \"],[10,\"img\"],[14,0,\"cNA--group__avatar--img\"],[15,\"src\",[30,1,[\"imageUrl\"]]],[12],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,1],[14,0,\"cNA--group__avatar--text\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[[30,1,[\"name\"]]],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"u--p__l__xs\"],[12],[1,\"\\n\"],[1,\"        \"],[10,0],[14,0,\"o--user__title u--ellipsis\"],[12],[1,\"\\n          \"],[10,1],[12],[1,[30,1,[\"name\"]]],[13],[1,\"\\n        \"],[13],[1,\"\\n\"],[1,\"        \"],[10,1],[14,0,\"u--block\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"account.groups.table.user_count\"],[[\"count\"],[[30,1,[\"nonContributorMemberCount\"]]]]]],[1,\"\\n        \"],[13],[1,\"\\n\"],[41,[30,0,[\"currentAccount\",\"canContributors\"]],[[[1,\"          \"],[10,1],[14,0,\"u--block\"],[14,\"data-test-id\",\"contributors count\"],[12],[1,\"\\n            \"],[1,[28,[35,2],[\"account.groups.table.contributor_count\"],[[\"count\"],[[30,1,[\"contributorCount\"]]]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[1,\"  \"],[10,\"td\"],[12],[1,\"\\n    \"],[8,[39,3],[[24,0,\"parentList\"]],[[\"@items\",\"@dragEndAction\",\"@draggingEnabled\",\"@additionalArgs\",\"@handle\",\"@determineForeignPositionAction\",\"@childClass\"],[[30,0,[\"identities\"]],[28,[37,4],[[30,0,[\"tradeIdentities\"]]],null],true,[28,[37,5],null,[[\"group\"],[[30,1]]]],\"[draggable]\",[28,[37,6],[[30,0],\"determineForeignPosition\"],null],\"cSS--setWrapper\"]],[[\"default\"],[[[[1,\"\\n      \"],[8,[39,7],null,[[\"@socialIdentity\",\"@editable\",\"@trade\",\"@index\",\"@clickedDetails\"],[[30,2,[\"identity\"]],[30,4],[28,[37,4],[[30,0,[\"tradeSocialProfile\"]]],null],[30,3],[28,[37,6],[[30,0],\"goToDetails\"],null]]],null],[1,\"\\n    \"]],[2,3]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"],[1,\"  \"],[10,\"td\"],[14,0,\"at--holisticOnboarding__editButtonCell\"],[12],[1,\"\\n\\n\"],[41,[30,5],[[[42,[28,[37,9],[[28,[37,9],[[30,0,[\"socialIdentities\"]]],null]],null],null,[[[1,\"        \"],[10,0],[14,0,\"cSS--detail\"],[12],[1,\"\\n\\n\"],[41,[30,6,[\"temporaryProfiles\"]],[[[1,\"            \"],[8,[39,10],null,[[\"@profiles\"],[[30,6,[\"temporaryProfiles\"]]]],[[\"default\"],[[[[1,\"\\n\"],[42,[28,[37,9],[[28,[37,9],[[30,7,[\"orderedProfiles\"]]],null]],null],null,[[[1,\"                \"],[10,0],[14,0,\"cSS--detail__li\"],[12],[1,\"\\n                  \"],[10,\"i\"],[15,0,[29,[\"i--\",[30,8,[\"profile\",\"profileType\"]]]]],[12],[13],[1,\" \"],[1,[30,8,[\"profile\",\"displayNickname\"]]],[1,\"\\n                \"],[13],[1,\"\\n\"]],[8]],null],[1,\"            \"]],[7]]]]],[1,\"\\n\"]],[]],[[[1,\"            \"],[8,[39,10],null,[[\"@profiles\"],[[30,6,[\"socialProfiles\"]]]],[[\"default\"],[[[[1,\"\\n\"],[42,[28,[37,9],[[28,[37,9],[[30,9,[\"orderedProfiles\"]]],null]],null],null,[[[1,\"                \"],[10,0],[14,0,\"cSS--detail__li\"],[12],[1,\"\\n                  \"],[10,\"i\"],[15,0,[29,[\"i--\",[30,10,[\"profileType\"]]]]],[12],[13],[1,\" \"],[1,[30,10,[\"displayNickname\"]]],[1,\"\\n                \"],[13],[1,\"\\n\"]],[10]],null],[1,\"            \"]],[9]]]]],[1,\"\\n\"]],[]]],[1,\"        \"],[13],[1,\"\\n\"]],[6]],null]],[]],null],[1,\"\\n\"],[41,[28,[37,11],[[28,[37,12],[[30,5]],null],[30,0,[\"currentUser\",\"isAccountOwner\"]]],null],[[[1,\"      \"],[8,[39,13],[[16,0,[29,[\"o--btn o--btn--outline u--float--right u--p__lr__md \",[52,[30,11],\"at--autoPublish__socialProfileDetails at--autoPublishEnable__socialProfileDetails at--holisticLibrary__socialSetsAndAccessGroups--editBtn\"]]]]],[[\"@route\",\"@model\",\"@query\"],[\"groups.group\",[30,1],[28,[37,5],null,[[\"new_social_profile_id\"],[null]]]]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,2],[\"account.groups.table.button\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@group\",\"socialIdentity\",\"index\",\"@editable\",\"@showProfileList\",\"set\",\"orderedProfiles\",\"profile\",\"orderedProfiles\",\"profile\",\"@isFirstGroup\"],false,[\"if\",\"word-initials\",\"t\",\"drag-sort-list\",\"perform\",\"hash\",\"action\",\"shared/social-identity\",\"each\",\"-track-array\",\"social-identity/sort-profiles\",\"and\",\"not\",\"link-to\"]]",
    "moduleName": "settings/components/groups/group-cover.hbs",
    "isStrictMode": false
  });

  let GroupCover = (_class = class GroupCover extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "router", _descriptor2, this);
    }

    get currentUser() {
      return this.auth.currentUserModel;
    }

    get currentAccount() {
      return this.auth.currentAccount;
    }

    get socialIdentities() {
      if (this.args.group.temporaryIdentities) {
        return this.args.group.temporaryIdentities.map(tempIdentity => tempIdentity.identity);
      }

      return this.args.group.socialIdentities || [];
    }

    get identities() {
      const items = [];
      this.socialIdentities.forEach(identity => {
        items.pushObject(_object.default.create({
          identity
        }));
      });
      return items;
    }

    determineForeignPosition(_ref2) {
      let {
        items
      } = _ref2;
      return items.length;
    }

    goToDetails() {
      this.router.transitionTo('account.groups.group', this.args.group.id);
    }

    *tradeIdentities(_ref3) {
      let {
        sourceList,
        sourceIndex,
        sourceArgs,
        targetArgs,
        targetIndex,
        targetList
      } = _ref3;

      if (targetIndex == undefined) {
        return;
      }

      const incoming = sourceList.objectAt(sourceIndex);
      this.args.trackGroupTrade(incoming);
      sourceList.removeAt(sourceIndex);
      targetList.insertAt(targetIndex, incoming);
      yield sourceArgs.group.set('temporaryIdentities', sourceList);
      yield targetArgs.group.set('temporaryIdentities', targetList);
      sourceArgs.group.set('traded', true);
      targetArgs.group.set('traded', true);
    }

    *tradeSocialProfile(_ref4) {
      let {
        sourceList,
        sourceIndex,
        sourceArgs,
        targetArgs,
        targetIndex,
        targetList
      } = _ref4;

      if (!targetArgs.socialIdentity) {
        return;
      }

      const incomingProfile = sourceList.objectAt(sourceIndex);
      const outgoingProfile = targetList.objectAt(sourceIndex);
      this.args.trackProfileTrade(incomingProfile);

      if (sourceArgs.socialIdentity.group.get('id') !== targetArgs.socialIdentity.group.get('id')) {
        this.args.trackProfileMovedAcrossGroups(incomingProfile);
      }

      yield sourceList.removeAt(sourceIndex);
      targetList.removeAt(sourceIndex);
      sourceList.insertAt(sourceIndex, outgoingProfile);
      targetList.insertAt(targetIndex, incomingProfile);
      sourceArgs.socialIdentity.set('temporaryProfiles', sourceList);
      targetArgs.socialIdentity.set('temporaryProfiles', targetList);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "determineForeignPosition", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "determineForeignPosition"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToDetails", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "goToDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tradeIdentities", [_emberConcurrencyDecorators.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "tradeIdentities"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "tradeSocialProfile", [_emberConcurrencyDecorators.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "tradeSocialProfile"), _class.prototype)), _class);
  _exports.default = GroupCover;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, GroupCover);
});